module.exports = __webpack_public_path__ + "media/tracking/Catalina-f873cff6.jpg";